module.exports = __webpack_public_path__ + "static/img/4.7f47b1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/third/4.png
// module id = ckR3
// module chunks = 6